var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"align-center":"","text-xs-center":""}},[_c('v-btn',{attrs:{"dark":"","color":_vm.color},on:{"click":_vm.clickBtn}},[_vm._t("default",[_c('v-icon',[_vm._v("vpn_key")])]),_vm._v(" "),_c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.handleFiles}})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb70702","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileReader.vue
// module id = ddj7
// module chunks = 1